<div class="background" id="background">
    <nav class="navbar navbar-submit animate__animated animate__slideInDown" id="nav">
        <a class="Ws-logo" [routerLink]="['/home']">{{ constants.WINDOW_SWAP_TXT }}</a>
        <!-- <div class="menus-data">
            <a><img class="profile-avatar" src="{{ constants.USER_ICON_BLUE }}" /></a>
            <div class="menu" [ngClass]="isPrime ? 'menu' : 'menu-notPrime'">

                <div class="user-menu">
                    <ul>
                        <li><a [routerLink]="['/Window']">{{constants.WINDOW_VIEWS}}</a></li>
                        <li>
                            <a [routerLink]="['/user/mywindow']">{{
                                constants.MENU_ITEMS.MY_WINDOW
                                }}</a>
                        </li>
                        <li>
                            <a [routerLink]="['/user']">{{
                                constants.MENU_ITEMS.MYBOOKMARK
                                }}</a>
                        </li>
                        <li>
                            <a [routerLink]="['/user/tipjar']">{{
                                constants.MENU_ITEMS.MY_TIPSJAR
                                }}</a>
                        </li>
                        <li>
                            <a [routerLink]="['/submit']">{{
                                constants.MENU_ITEMS.SUBMIT_WINDOW
                                }}</a>
                        </li>
                        <li (click)="Takemetoprime()" id="menu-item" *ngIf="!isPrime">
                            <button class="menu-submit-button">
                                {{ constants.MENU_ITEMS.GET_ALL_ACCESS }}
                            </button>
                        </li>

                        <hr class="user-menu-line" />
                        <li>
                            <button class="user-logout" (click)="logout()">
                                {{ constants.MENU_ITEMS.LOGOUT }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div> -->
        <img (click)="OnClickClose()" class="close-button profile-avatar" src="{{constants.LOGIN_CLOSE_BUTTON}}" />


    </nav>
    
    <div>
        <div class="row contentBody">
            <div class="col-3 text-left d-none d-md-block">
                <div class="sideMenu">
                    <div class="sectionHeaders">
                        <li (click)="scrollToDiv('introduction')">Introduction</li>
                        <li (click)="scrollToDiv('useOfService')">Use of Service</li>
                        <li (click)="scrollToDiv('useOfService')">Content on service</li>
                        <li (click)="scrollToDiv('yourContentAndConduct')">Your Content & conduct</li>
                        <li (click)="scrollToDiv('otherLegalTerms')">Other Legal Terms</li>
                        <li (click)="scrollToDiv('privacyPolicy')">Privacy Policy</li>
                    </div>
                </div>
            </div>
            <div class="col-9 text-left d-none d-md-block">
                <div class="termsBody" #targetDiv>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_1">
                        <div [id]=" hasId(content)"
                            [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                            {{content.data}}
                        </div>
                    </div>
                    <ol>
                        <li *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_2">
                            <div [id]=" hasId(content)"
                                [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                                {{content.data}}
                            </div>
                        </li>
                    </ol>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_3">
                        <div [id]=" hasId(content)"
                            [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                            {{content.data}}
                        </div>
                    </div>
                    <ol>
                        <li *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_4">
                            <div [id]=" hasId(content)"
                                [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent2': content.type == 'H4'}">
                                {{content.data}}
                            </div>
                        </li>
                    </ol>
                    <br>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_5">
                        <div [id]=" hasId(content)"
                            [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4', 'paraContent2': content.type == 'H4.1', 'paraContent3': content.type == 'H4.2'}">
                            {{content.data}}
                        </div>
                        <!-- The section below is commented out because Publift ads need to be removed. -->
                        <!-- <div data-fuse-privacy-tool style="margin-bottom: 2rem;" *ngIf="content.type == 'ads-privacyPlolicy'"></div> -->
                    </div>
                    <br>
                    <br>
                    <br>
                </div>
                
            </div>

            <!-- for mobile view  -->

            <div class="col-12 text-left d-md-none container smallScreen">
                <div>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_1">
                        <div
                            [ngClass]="{'hide' : content.type == 'H1', 'd-none' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                            
                            {{content.data}}
                        </div>
                    </div>
                    <ol>
                        <li *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_2">
                            <div
                                [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                                {{content.data}}
                            </div>
                        </li>
                    </ol>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_3">
                        <div
                            [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4'}">
                            {{content.data}}
                        </div>
                    </div>
                    <ol>
                        <li *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_4">
                            <div
                                [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent2': content.type == 'H4'}">
                                {{content.data}}
                            </div>
                        </li>
                    </ol>
                    <br>
                    <div *ngFor="let content of constants.TERMS_AND_CONDITIONS.TNC_CONTENT_5">
                        <div
                            [ngClass]="{'mainHeading' : content.type == 'H1', 'dateText' : content.type == 'D1', 'sectionHeader' : content.type == 'H2', 'paraHeading' : content.type == 'H3', 'paraContent': content.type == 'H4', 'paraContent2': content.type == 'H4.1', 'paraContent3': content.type == 'H4.2'}">
                            {{content.data}}
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
</div>